export default "__VITE_ASSET__ZSo_4SsW__"